export enum VehiclesConstants {
  GET_VEHICLES_LIST_REQUEST = 'GET_VEHICLES_LIST_REQUEST',
  GET_VEHICLES_LIST_SUCCESS = 'GET_VEHICLES_LIST_SUCCESS',
  GET_VEHICLES_LIST_FAILURE = 'GET_VEHICLES_LIST_FAILURE',
  RESET_STATE = 'RESET_STATE',
}
